import {
  REVENUE_GL_HEAD_REQUEST,
  REVENUE_GL_HEAD_SUCCESS,
  REVENUE_GL_HEAD_FAIL,

  CREATE_REVENUE_GL_HEAD_REQUEST,
  CREATE_REVENUE_GL_HEAD_SUCCESS,
  CREATE_REVENUE_GL_HEAD_FAIL,

  UPDATE_REVENUE_GL_HEAD_REQUEST,
  UPDATE_REVENUE_GL_HEAD_SUCCESS,
  UPDATE_REVENUE_GL_HEAD_FAIL,

  DELETE_REVENUE_GL_HEAD_REQUEST,
  DELETE_REVENUE_GL_HEAD_SUCCESS,
  DELETE_REVENUE_GL_HEAD_FAIL,

  CLEAR_ERROR,
} from "../../../constants/Master/CoaMasters/RevenueGlHeadConstant";


// create, update, delete and get all
export const getRevenueGlHeadsReducer = (state = { revenueGlHeads: [] }, action) => {
  switch (action.type) {
    case REVENUE_GL_HEAD_REQUEST:
    case CREATE_REVENUE_GL_HEAD_REQUEST:
    case UPDATE_REVENUE_GL_HEAD_REQUEST:
    case DELETE_REVENUE_GL_HEAD_REQUEST:
      return {
        ...state,
        loading: true,
        message: null,
        status: null,
        error: null,
      };

    case REVENUE_GL_HEAD_SUCCESS:
      return {
        ...state,
        loading: false,
        revenueGlHeads: action.payload,
        message: null,
        status: null,
      };

    case CREATE_REVENUE_GL_HEAD_SUCCESS:
      return {
        ...state,
        loading: false,
        revenueGlHeads: [...state.revenueGlHeads, action.payload],
        message: action.message,
        status: action.status,
      };

    case UPDATE_REVENUE_GL_HEAD_SUCCESS:
      return {
        ...state,
        loading: false,
        revenueGlHeads: state.revenueGlHeads.map((item) =>
          (item.glHeadId === action.payload.glHeadId) ? action.payload : item
        ),
        message: action.message,
        status: action.status,
      };

    case DELETE_REVENUE_GL_HEAD_SUCCESS:
      return {
        ...state,
        loading: false,
        revenueGlHeads: action?.payload?.isDelete ?
          state.revenueGlHeads.filter((item) =>
            item.glHeadId !== action.payload.glHeadId
          )
          :
          state.revenueGlHeads.map((item) =>
            (item.glHeadId === action.payload.glHeadId) ? action.payload : item
          ),
        message: action.message,
        status: action.status,
      };

    case REVENUE_GL_HEAD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_REVENUE_GL_HEAD_FAIL:
    case UPDATE_REVENUE_GL_HEAD_FAIL:
    case DELETE_REVENUE_GL_HEAD_FAIL:
      return {
        ...state,
        loading: false,
        message: action.message,
        status: action.status,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
        status: null,
        message: null,
      };

    default:
      return state;
  }
};